// apolo/src/lib/loop/condenserGate.js — harness-uplift-r2 E2 glue.
//
// Thin renderer-side glue between the pure condenser engine (condenser.js) and
// the kill-switch flag (sprintFlags.js). Kept out of the pure engine so
// condenser.js stays window-free (Dependency Rule). Never throws.
//
// When ON, produces a PARTIAL-condensation summary (older events condensed,
// recent kept verbatim) to feed the existing compact marker — richer than the
// all-or-nothing reset digest. When OFF, returns null → caller uses the legacy
// deterministic buildCompactSummary (byte-identical).

import { buildView } from '../condenser.js';
import { readCondenserEnabled } from '../../flags/sprintFlags.js';

/**
 * Flag-gated partial-condensation summary. Returns a summary string when
 * `apolo_condenser` is ON, or null when OFF. `summarizeFn` is injected
 * (multi-LLM LAW); absent → the condenser's deterministic fallback is used.
 *
 * @param {Array<object>} liveMessages
 * @param {{ summarizeFn?: Function, keepRecent?: number }} [opts]
 * @returns {string|null}
 */
export function condenserSummaryIfEnabled(liveMessages, opts = {}) {
  if (!readCondenserEnabled()) return null;
  const { condensation } = buildView(liveMessages, {
    keepRecent: opts.keepRecent,
    summarizeFn: opts.summarizeFn,
  });
  return condensation ? condensation.summary : null;
}
